<template>
  <div class="customer-management-contacts">
    <div class="title">
      <div class="text">
        全部客户
        <span
          >共 <b>{{ total || 0 }}</b> 个联系人</span
        >
      </div>
      <el-button type="primary" size="small" @click="handleImport">导入联系人</el-button>
    </div>
    <div class="subject">
      <div class="search">
        <!-- 固定搜索条件 -->
        <div class="fixed">
          <div class="left">
            <div class="search-item search-item-special">
              <!-- <el-select
                size="small"
                v-model="searchData.type"
                slot="prepend"
                placeholder="请选择"
                @change="keySelectChange"
              >
                <el-option
                  v-for="item in keywordOptions"
                  :label="item.name"
                  :value="item.key"
                  :key="item.key"
                ></el-option>
              </el-select> -->
              <el-input
                placeholder="客户名称/联系人姓名/手机/邮箱/备注"
                v-model="searchData.keyword"
                class="input-with-select"
                size="small"
                clearable
              >
                <el-button
                  size="small"
                  slot="append"
                  icon="iconfont icon-icon-fangdajing"
                  @click="search"
                ></el-button>
              </el-input>
            </div>
            <div class="search-item search-item-source">
              <div class="label">来源:</div>
              <el-select
                v-model="searchData.source"
                @change="sourceChange"
                multiple
                placeholder="全部客户"
                collapse-tags
                clearable
              >
                <el-option
                  v-for="item in saasSupplierCustomerUserSourceOptions"
                  :label="item.name"
                  :value="item.codeValue"
                  :key="item.codeValue"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="right"></div>
        </div>
      </div>
      <div class="content">
        <div  class="jumpEmaildiv">
          <span  class="jumpEmailSlect">已选 <span>{{handleSelectionList.length}}</span> 个</span>
          <span class="primaryBtn">
            <!-- :disabled="handleSelectionList.length==0" -->
            <el-button  size="small" class="smallBtn"  @click="jumpEmail" >发送邮件</el-button>
          </span>
        </div>
        <el-table
          class="fine-scroll-bar"
          size="small"
          width="100%"
          :data="tableData"
          @sort-change="sortChange"
          v-loading="loading"
          :default-sort="{ prop: '3', order: 'descending' }"
          max-height="550px"
          tooltip-effect="light customer-management-contacts-tooltips"
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <div class="no-content-slot"></div>
          </template>
          <el-table-column
            type="selection"
            width="55" align="center">
          </el-table-column>
          <!-- 主要联系人 -->
          <el-table-column min-width="140" label="联系人" fixed="left">
            <template slot-scope="scope">
              <el-tooltip
                effect="light"
                :content="scope.row.contactName"
                placement="bottom"
                :disabled="isShowTooltip"
              >
                <p
                  class="customer-management-contacts-tooltip-p tooltip-contactName"
                  @mouseover="
                    onMouseOver('contactNameStrTootip' + scope.$index)
                  "
                >
                  <span
                    :ref="'contactNameStrTootip' + scope.$index"
                    style="color: #066eb7; cursor: pointer"
                    @click="
                      openContactDetail(
                        scope.row.id,
                        scope.row.customerId,
                        scope.$index
                      )
                    "
                  >
                    {{ scope.row.contactName | noText }}
                  </span>
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 职务 -->
          <el-table-column min-width="150" label="职务">
            <template slot-scope="scope">
              <el-tooltip
                effect="light"
                :content="scope.row.titleStr"
                placement="bottom"
                :disabled="isShowTooltip"
                popper-class="customer-management-potential-contacts-title-tooltip"
              >
                <p
                  class="customer-management-contacts-tooltip-p tooltip-title"
                  @mouseover="onMouseOver('titleStrTootip' + scope.$index)"
                >
                  <span :ref="'titleStrTootip' + scope.$index">{{
                    scope.row.titleStr | noText
                  }}</span>
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 客户名称 -->
          <el-table-column min-width="170" label="客户名称">
            <template slot-scope="scope">
              <el-tooltip
                v-if="scope.row.customerId"
                effect="light"
                :content="scope.row.companyName"
                placement="bottom"
                :disabled="isShowTooltip"
              >
                <p
                  class="customer-management-contacts-tooltip-p tooltip-companyName"
                  @mouseover="
                    onMouseOver('companyNameStrTootip' + scope.$index)
                  "
                >
                  <span
                    :ref="'companyNameStrTootip' + scope.$index"
                    style="color: #066eb7; cursor: pointer"
                    @click="openDetail(scope.row.customerId, scope.$index)"
                  >
                    {{ scope.row.companyName | noText }}
                  </span>
                </p>
              </el-tooltip>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <!-- 最近阅读邮件时间  -->
          <el-table-column
            prop="4"
            sortable="custom"
            min-width="180"
            label="最近阅读邮件时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.recentlyReadTime | format('YYYY-MM-DD HH:mm') }}
              </div>
            </template>
          </el-table-column>
          <!-- 最后跟进时间  -->
          <el-table-column
            prop="1"
            sortable="custom"
            min-width="150"
            label="最后跟进时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.lastFollowupTime | format('YYYY-MM-DD HH:mm') }}
              </div>
            </template>
          </el-table-column>
          <!-- 备注 -->
          <el-table-column min-width="150" label="备注">
            <template slot-scope="scope">
              <el-tooltip
                effect="light"
                :content="scope.row.remark"
                placement="bottom"
                :disabled="isShowTooltip"
                popper-class="customer-management-potential-contacts-remark-tooltip"
              >
                <p
                  class="customer-management-contacts-tooltip-p tooltip-remark"
                  @mouseover="onMouseOver('remarkStrTootip' + scope.$index)"
                >
                  <span :ref="'remarkStrTootip' + scope.$index">{{
                    scope.row.remark | noText
                  }}</span>
                </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 来源 -->
          <el-table-column min-width="150" label="来源" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{
                (
                  saasSupplierCustomerUserSourceOptions.find(
                    (ele) => ele.codeValue === scope.row.source
                  ) || {}
                ).name | noText
              }}</span>
            </template>
          </el-table-column>
          <!-- 添加时间  -->
          <el-table-column
            prop="2"
            sortable="custom"
            min-width="170"
            label="添加时间"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.addUserTime | format }}</div>
            </template>
          </el-table-column>
          <!-- 最后操作时间  -->
          <el-table-column
            prop="3"
            sortable="custom"
            min-width="170"
            label="最后操作时间"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.operateTime | format }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="no-content" v-if="!tableData || !tableData.length">
          <img src="@/assets/image/common/noData.png" alt="" />
          <p>暂无数据</p>
        </div>
        <div class="pagination">
          <el-pagination
            v-show="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="currentChange"
            :page-sizes="[10, 20, 50, 100]"
            :current-page="curPage"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <DetailDrawer
      ref="detailDrawer"
      :companyDataProp="companyData"
      :contactDataProp="contactData"
      @emitAnewList="anewList"
    />

    <!-- 导入数据功能 -->
    <ContactsImport @getList="getList" />
    <!-- 套餐购买 -->
    <vipBoxDialog :vipCode="vipCode" ref="vipBoxDialog" :typeOpen="false"/>
  </div>
</template>

<script>
import DetailDrawer from '@/components/custom/DetailDrawer'
import customerListMinxis from '@/mixins/customerList.js'
import { getUserList } from '@/utils/api/customer.js'
import { mapMutations, mapState } from 'vuex'
import { strEnterReplace } from '@/utils/common.js'
import ContactsImport from '@/components/customer-follow/ContactsImport'
import { getSingleDictByType } from '@/utils/api/common.js'
import vipBoxDialog from "@/components/common/VIPdialog"
import { usersendEmailVerifyBulk,verifyBulkIdsConversion } from '@/utils/api/edmSubject'
export default {
  components: {
    DetailDrawer,
    ContactsImport,
    vipBoxDialog
  },
  mixins: [customerListMinxis],
  computed: {
    ...mapState('contactsImport', ['show', 'status']),
  },
  data() {
    return {
      tabPosition: '',
      isSpecialFocus: false,
      searchData: {
        keyword: '',
        type: 1,
        source: [],
      },
      copySearchData: {},
      companyData: {
        id: null,
        ids: [],
        index: null,
      },
      keywordOptions: [
        {
          key: 1,
          name: '客户名称',
        },
        {
          key: 2,
          name: '联系人',
        },
        {
          key: 3,
          name: '手机',
        },
        {
          key: 4,
          name: '电话',
        },
        {
          key: 5,
          name: '邮箱',
        },
        {
          key: 6,
          name: '备注',
        },
      ],
      contactData: {
        id: null,
        ids: [],
        index: null,
        cid: null,
        cids: [],
      },
      emailList: [],
      sort: {},
      saasSupplierCustomerUserSourceOptions: [],
      handleSelectionList:[],
      vipCode:7002,//7001, "套餐可用额度不足" ,  7002, "套餐无可用额度
      sendEmailDis:true,
      uuid:'',

      curPage: 1,
      pageSize: 100
    }
  },
  methods: {
    ...mapMutations('contactsImport', [
      'SET_SHOW',
      'SET_STATUS',
      'SET_VISIBLE',
    ]),
    strEnterReplace,
    // 表格多选
    handleSelectionChange(val) {
      console.log(val)
      this.handleSelectionList=[]
      val.map((item)=>{
        this.handleSelectionList.push(item.id)
      })
      console.log(this.handleSelectionList)
    },
    // 发送邮件
    jumpEmail(){
      if(this.handleSelectionList.length==0){
        this.$message.error('请至少选择一个客户')
      }else{
        if(this.sendEmailDis){
          this.sendEmailDis=false
          let params={
            ids:this.handleSelectionList
          }
          verifyBulkIdsConversion(params).then((res)=>{
            console.log(res)
            if(res.rspResult.bizCode==200){
              this.uuid=res.data.value
              let bodys={
                uuid:this.uuid
              }
              usersendEmailVerifyBulk(bodys).then(res=>{
                if(res.rspResult.bizCode==200){
                  let routeUrl = this.$router.resolve({
                    name:`contactsSendEmail`,
                    query:{
                      userIds: this.uuid,
                    }
                  }).href
                  window.open(routeUrl, '_blank');
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                
                }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
                  this.vipCode=res.rspResult.bizCode
                  this.$refs.vipBoxDialog.centerDialogVisible=true
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                }else{
                  this.$message.error(res.rspResult.message)
                  setTimeout(()=>{
                    this.sendEmailDis=true
                  },1000)
                }
              })
            }else if(res.rspResult.bizCode==7001||res.rspResult.bizCode==7002){
              this.vipCode=res.rspResult.bizCode
              this.$refs.vipBoxDialog.centerDialogVisible=true
              setTimeout(()=>{
                this.sendEmailDis=true
              },1000)
            }else{
              this.$message.error(res.rspResult.message)
              setTimeout(()=>{
                this.sendEmailDis=true
              },1000)
            }
          })

        }

      }
    },
    // 获取列表数据
    async getList(isTop = true) {
      this.loading = true
      try {
        const params = {
          ...this.copySearchData,
          attentionStatus: this.attentionStatus || undefined, // 特别关注
          pageSize: this.pageSize,
          curPage: this.curPage,
          ...this.sort,
          // 以下代码清除不需要的入参，避免带入接口
          keyword: this.copySearchData.keyword.trim() || undefined,
          // attribute:4,
        }
        if (!this.copySearchData.keyword.trim()) params.type = undefined
        const res = await getUserList(params)
        if (res.rspResult.bizCode === 200) {
          this.tableData = res.rspPageData.list
          this.tableData.forEach((item) => {
            this.emailList.push(item.email)
          })
          this.emailList = this.emailList.filter((i) => {
            return i != ''
          })
          this.total = res.rspPageData.totalNum
          if(isTop) this.returnTop()
        } else {
          this.total = 0
        }
        this.loading = false
      } catch (err) {
        this.total = 0
        this.loading = false
        console.error('❌ ~ file: contacts.vue:411 ~ getList ~ err:', err)
      }
    },

    // 点击导入按钮
    handleImport() {
      if (this.show && this.status === 1) {
        return this.$message.error('当前有任务正在导入中')
      }
      if (this.status === 2) this.SET_STATUS(0) // 如果当前导出状态为已完成，再次点击重置为默认
      this.SET_SHOW(true)
      this.SET_VISIBLE(true)
    },

    // 点击打开联系人详情
    openContactDetail(id, cid, index) {
      this.contactData = {
        id,
        ids: this.tableData.map((ele) => ele.id),
        index,
        cid,
        cids: this.tableData.map((ele) => ele.customerId),
      }
      const ref = this.$refs.detailDrawer
      ref.isList = true
      ref.isCustomerDetail = false
      ref.visible = true
    },

    // 点击打开详情
    openDetail(id, index) {
      this.companyData = {
        id,
        ids: this.tableData.map((ele) => ele.id),
        index,
      }
      const ref = this.$refs.detailDrawer
      ref.isList = false
      ref.isCustomerDetail = true
      ref.visible = true
    },

    async initData() {
      try {
        const res = await getSingleDictByType(
          'saas_supplier_customer_user_source'
        )
        if (res.rspResult.bizCode === 200) {
          this.saasSupplierCustomerUserSourceOptions = res.rspListData.list
        }
      } catch (err) {
        console.error('❌ ~ file: contacts.vue:464 ~ initData ~ err:', err)
      }
    },

    sourceChange() {
      this.copySearchData.source = this.searchData.source
      this.searchData = JSON.parse(JSON.stringify(this.copySearchData))
      this.curPage = 1
      this.handleSelectionList=[]
      this.getList()
    },
  },
  created() {
    this.copySearchData = JSON.parse(JSON.stringify(this.searchData))
    this.getList()
    this.getInitTagList()
    this.initData()
  },
}
</script>

<style lang="scss" src="./style/potential.scss" scoped></style>
<style lang="scss" scoped>
.customer-management-contacts {
  > .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-button {
      font-size: 14px;
    }
  }
  .search-item-source {
    margin-left: 20px;
    .label {
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #4f5d78;
      margin-right: 16px;
    }
  }
  ::v-deep .el-select {
    input {
      font-size: 14px;
    }
  }
  .customer-management-contacts-tooltip-p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.jumpEmaildiv{
  margin-left: 22px;
  margin-bottom: 12px;
  .jumpEmailSlect{
    font-size: 14px;
    color: #16181a;
    span{
      color: #066EB7;
      font-size: 14px;
    }
  }
  .primaryBtn{
    margin-left: 32px;
    font-size: 14px;
    color: #4F5D78;
    .smallBtn{
      font-size: 14px;
      color: #4F5D78;
    }
    .smallBtn:hover{
      font-size: 14px;
      color: #4F5D78;
      border: 1px solid #066eb7;
      background: #066eb71a;
      /* border-left-width: 0; */
      color: #066eb7;
    }
  }
}
::v-deep .pagination{
  .el-pagination{
    .el-pagination__total{
      color: #4f5d78;
    }
  }
}
</style>
<style lang="scss">
.customer-management-potential-contacts-remark-tooltip,
.customer-management-potential-contacts-title-tooltip {
  max-width: 300px;
  .popper__arrow {
    border-color: #ebeef5 !important;
  }
}
.customer-management-contacts {
  .tooltip-contactName {
    max-width: 120px;
  }
  .tooltip-companyName {
    max-width: 150px;
  }
  .tooltip-title {
    max-width: 130px;
  }
  .tooltip-remark {
    width: 130px;
  }
}
</style>
